import { IEmailReceptivo } from "../../../../Interfaces/Geral/GestaoDeCadastro/Emailconta/EmailReceptivoInterface";

import Axios from "../../../Config/API";
import Service from "../../../Service";

export async function CadastrarEmailReceptivoService(
    requestBody: IEmailReceptivo
) {
    return Service(
        Axios.post(`/home/emailconta/cadastraremailcontareceptivo`, requestBody)
    );
}

export async function DeletarEmailReceptivoService(idEmailReceptivo: number) {
    return Service(
        Axios.delete(
            `/home/emailconta/deletaremailcontareceptivo?idEmailContaReceptivo=${idEmailReceptivo}`
        )
    );
}

export async function AtualizarEmailReceptivoService(
    requestBody: IEmailReceptivo
) {
    return Service(
        Axios.put(`/home/emailconta/atualizaremailcontareceptiva`, requestBody)
    );
}

export async function ListarEmailReceptivoService() {
    return Service(
        Axios.get<Array<IEmailReceptivo>>(
            `/home/emailconta/emailcontareceptiva`
        )
    );
}

export async function GetEmailReceptivoService(idEmailReceptivo: number) {
    return Service(
        Axios.get<IEmailReceptivo>(
            `/home/emailconta/getemailcontareceptiva?idEmailContaReceptiva=${idEmailReceptivo}`
        )
    );
}
